'use client';

// import { AnimatePresence, motion } from 'framer-motion';
import Image from 'next/image';
import { useEffect, useState } from 'react';

interface Slide {
  image: string;
  title: string;
  description: string;
  extra?: string;
}

const slides: Slide[] = [
  {
    image: '/banner/siberia1.jpg',
    title: 'Путешествие по Сибири',
    description: 'Исследуй красоту природы и свежий воздух.',
    extra: 'Томская область, 2025',
  },
  {
    image: '/banner/siberia2.jpg',
    title: 'Зимняя сказка',
    description: 'Сибирь зимой — это магия снега и тишины.',
    extra: 'Февральские дали',
  },
  {
    image: '/banner/siberia3.jpg',
    title: 'Лето в тайге',
    description: 'Время для походов, костров и ягод.',
    extra: 'Июльский лес',
  },
];

export default function Banner() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 10000);
    return () => clearInterval(interval);
  }, []);

  return (
    <a
      href="http://siberia-tours.com/?utm_source=new_sib&utm_term=%D0%9F%D1%83%D1%82%D0%B5%D1%88%D0%B5%D1%81%D1%82%D0%B2%D0%B8%D0%B5%20%D0%BF%D0%BE%20%D0%A1%D0%B8%D0%B1%D0%B8%D1%80%D0%B8&yclid=11346720711500365823"
      target="_blank"
      className="block w-full h-full group"
      rel="noopener noreferrer"
    >
      <div className="relative w-full overflow-hidden shadow-lg rounded-lg h-[300px]">
        {slides.map((slide, i) => (
          <div
            key={slide.image}
            className={`absolute inset-0 w-full h-full transition-opacity duration-700 ${
              i === index ? 'opacity-100' : 'opacity-0 pointer-events-none'
            }`}
          >
            <Image
              src={slide.image}
              alt={slide.title}
              fill
              quality={65}
              priority={i === 0}
              sizes="(max-width: 767px) 100vw, (max-width: 1279px) 50vw, 300px"
              className="object-cover"
            />
            <div className="absolute inset-0 bg-black/50" />
          </div>
        ))}

        <div className="absolute z-10 inset-0 flex flex-col justify-center items-center text-center text-white p-4 min-h-[300px]">
          <h2 className="text-xl md:text-2xl font-bold drop-shadow-md min-h-8">
            {slides[index].title}
          </h2>
          <p className="mt-2 text-sm md:text-base min-h-10">{slides[index].description}</p>
          {slides[index].extra && (
            <span className="mt-auto pt-4 text-xs text-gray-300">{slides[index].extra}</span>
          )}
        </div>
      </div>
    </a>
  );
}
